import script from "./casePage.vue?vue&type=script&setup=true&lang=js"
export * from "./casePage.vue?vue&type=script&setup=true&lang=js"

import "./casePage.vue?vue&type=style&index=0&id=322883e2&lang=less&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322883e2"]])

export default __exports__